export type PageRoute = {
	name: string;
	sysName: string;
	path: string;
	components: Array<string>;
	rights: Array<string | Array<string>>;
	title: string;
	showInMenu?: boolean;
};

const BASE_URL = '/partners';
const appPageRoutes: Array<PageRoute> = [
	{
		name: 'Партнер',
		title: 'Партнер - Seeneco',
		sysName: 'leads',
		components: [],
		rights: [],
		path: `${BASE_URL}/cabinet`,
		showInMenu: true,
	},
	{
		name: 'Авторизация',
		title: 'Авторизация - Seeneco',
		sysName: 'login',
		components: [],
		rights: [],
		path: `${BASE_URL}/login`,
	},
];

const getIsAvailibleRoute = (components: Array<ApplicationComponent>, rights: Array<SecurityRight>, isFullAccess: boolean, page: PageRoute) => {
	const hasComponets = components && page.components.every(pageC => components.some(tenantC => pageC == tenantC.SystemName));
	const hasRights = !isFullAccess
		? rights && page.rights.every(pageR => {
			return rights.some(userR => {
				return Array.isArray(pageR) ? pageR.some(itemPageR => itemPageR === userR.SystemName) : pageR === userR.SystemName;
			});
		})
		: true;

	return hasComponets && hasRights;
}

const filterRoutes = (components: Array<ApplicationComponent>, rights: Array<SecurityRight>, routes: Array<PageRoute> = [], isAuthorized: boolean = false, isFullAccess: boolean = false) => {
	const filteredRoutes = routes
		.filter(p => isAuthorized ? p.sysName !== 'login' : p.sysName === 'login')
		.filter(p => getIsAvailibleRoute(components, rights, isFullAccess, p))

	return filteredRoutes;
};

export {
	appPageRoutes,
	filterRoutes,
	BASE_URL,
};
